"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STANDARD_ALTITUDE_PLANET_REFRACTION = exports.STANDARD_ALTITUDE_MOON_CENTER_REFRACTION = exports.STANDARD_ALTITUDE_SUN_ASTRONOMICAL_TWILIGHT = exports.STANDARD_ALTITUDE_SUN_NAUTICAL_TWILIGHT = exports.STANDARD_ALTITUDE_SUN_CIVIL_TWILIGHT = exports.STANDARD_ALTITUDE_SUN_UPPER_LIMB_REFRACTION = exports.STANDARD_ALTITUDE_SUN_CENTER_REFRACTION = exports.STANDARD_ALTITUDE_SUN_UPPER_LIMB = exports.STANDARD_ALTITUDE_SUN_CENTER = void 0;
exports.STANDARD_ALTITUDE_SUN_CENTER = -0;
exports.STANDARD_ALTITUDE_SUN_UPPER_LIMB = -0.25;
exports.STANDARD_ALTITUDE_SUN_CENTER_REFRACTION = -0.583;
exports.STANDARD_ALTITUDE_SUN_UPPER_LIMB_REFRACTION = -0.833;
exports.STANDARD_ALTITUDE_SUN_CIVIL_TWILIGHT = -6;
exports.STANDARD_ALTITUDE_SUN_NAUTICAL_TWILIGHT = -12;
exports.STANDARD_ALTITUDE_SUN_ASTRONOMICAL_TWILIGHT = -18;
exports.STANDARD_ALTITUDE_MOON_CENTER_REFRACTION = 0.125;
exports.STANDARD_ALTITUDE_PLANET_REFRACTION = -0.5667;
